import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initGA } from './analytics';


const root = ReactDOM.createRoot(document.getElementById('root'));
// Initialize Google Analytics (no-op if measurement ID is not replaced)
try {
  initGA();
} catch (e) {
  // ignore initialization errors in environments without window
}
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
